module.exports = __webpack_public_path__ + "static/img/35-1.ef1907e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/35-1.jpg
// module id = UhxI
// module chunks = 0